/* eslint-disable @typescript-eslint/no-explicit-any */
import IconAggregate from '@assets/icons/aggregate.svg?react';
import IconBigArrowBottom from '@assets/icons/big arrow bottom.svg?react';
import IconBigArrowTop from '@assets/icons/big arrow top.svg?react';
import IconFilters from '@assets/icons/filters.svg?react';
import IconGroup from '@assets/icons/group.svg?react';
import { Box } from '@mui/material';
import { GridPremiumSlotsComponent } from '@mui/x-data-grid-premium';

import HeaderFilterIcon from './HeaderFilterIcon';

const gridSlotsIcons = {
 columnHeaderFilterIconButton: HeaderFilterIcon,
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuFilterIcon: () => (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
   }}
  >
   <IconFilters />
  </Box>
 ),
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuGroupIcon: () => (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
   }}
  >
   <IconGroup />
  </Box>
 ),
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuUngroupIcon: () => (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
   }}
  >
   <IconGroup />
  </Box>
 ),
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuSortAscendingIcon: () => (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
   }}
  >
   <IconBigArrowTop />
  </Box>
 ),
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuSortDescendingIcon: () => (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
   }}
  >
   <IconBigArrowBottom />
  </Box>
 ),
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuAggregationIcon: () => (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
   }}
  >
   <IconAggregate />
  </Box>
 ),
} as Partial<GridPremiumSlotsComponent>;

export default gridSlotsIcons;
